import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";

import {withTranslation} from 'react-i18next';
import Input from "../../UI/Input/Input";
import {toast} from "react-toastify";
import PageTitle from "../../Commons/PageTitle";
import axios from "../../../axios-defaults";
import Spinner from "../../UI/Spinner";

class NewAccountForm extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            success: false,
            loading: false,
            validationLoading: false,
            formIsValid: true,
            generated_url: '',
            form: {
                elements: {
                    firstname: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'text',
                            name: 'firstname',
                            autoComplete: 'firstname',
                            id: 'firstname'
                        },
                        visible: true,
                        className: "col-md-6",
                        label: "popup.generate_token.form.firstname",
                        placeholder: 'linkedaccounts.table.header.firstname',
                        value: '',
                        validationRules: {
                            required: false
                        },
                        valid: true,
                        touched: false
                    },
                    lastname: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'text',
                            name: 'lastname',
                            autoComplete: 'lastname',
                            id: 'lastname',
                        },
                        visible: true,
                        className: "col-md-6",
                        label: "popup.generate_token.form.lastname",
                        placeholder: 'linkedaccounts.table.header.lastname',
                        value: '',
                        validationRules: {
                            required: false
                        },
                        valid: true,
                        touched: false
                    },
                    phone: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'text',
                            name: 'phone',
                            autoComplete: 'phone',
                            id: 'phone',
                        },
                        visible: true,
                        className: "col-md-6",
                        label: "popup.generate_token.form.phone",
                        placeholder: 'popup.generate_token.form.phone',
                        value: '',
                        validationRules: {
                            required: false
                        },
                        valid: true,
                        touched: false
                    },
                    email: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'text',
                            placeholder: '',
                            name: 'current-email',
                            autoComplete: 'current-email',
                            id: 'txt_email',
                        },
                        className: "col-md-6",
                        label: "popup.generate_token.form.email",
                        value:'',
                        defaultValue:'',
                        validationRules:{
                            required:false,
                            nullable:true,
                            matchRegex:"^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$"
                        },
                        valid: true,
                        visible: true,
                        touched: false,
                        errorMessages: {
                            matchRegex : "errors.validemail"
                        },
                        errorMessage: "errors.fieldrequired"
                    }/*,
                    confirmEmail: {
                        elementType: 'input',
                        elementConfigs: {
                            type: 'email',
                            placeholder: '',
                            name: 'confirm-email',
                            autoComplete: 'confirm-email',
                            id: 'txt_confirm_email',
                        },
                        className: "col-md-6",
                        label: "popup.generate_token.form.confirm_email",
                        value:'',
                        validationRules:{
                            nullable:true,
                            matchRegex:"^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$",
                            match: 'email'
                        },
                        valid: true,
                        visible: false,
                        touched: false,
                        confirmiEditField: 'email',
                        errorMessages: {
                            matchRegex : "errors.validemail",
                            match : "errors.emailnotmatch",
                            required : "errors.fieldrequired"
                        },
                        errorMessage: "errors.fieldrequired"
                    }*/
                }
            }
        }
    }

    copyClipboard = () => {
        navigator.clipboard.writeText(this.state.generated_url);
        toast.info(
            <div>
                <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("misc.copied_to_clipboard")}
            </div>
        );
    }

    validateForm = () => {
        const form = {...this.state.form};
        let formIsValid = true;
        for(let inputIdentifier in form.elements){
            if (form.elements[inputIdentifier].elementConfigs.type == 'hidden')
                continue;

            const validationResult = this.checkValidity(form.elements[inputIdentifier], form.elements[inputIdentifier].value, form.elements[inputIdentifier].validationRules);
            if (!validationResult.valid){
                form.elements[inputIdentifier].valid = false;
                form.elements[inputIdentifier].touched = true;
                form.elements[inputIdentifier].errorMessage = validationResult.errorMessages.join(', ')
            }

            formIsValid = formIsValid && form.elements[inputIdentifier].valid;
        }
        this.setState({
            form: form,
            formIsValid: formIsValid
        });

        return formIsValid;
    }

    generateCreationToken = () => {
        if(!this.validateForm()){
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('generate_token.invalid_form')}
                </div>
            );
            return false;
        }

        this.setState({
            loading: true
        });

        const {firstname,lastname,phone,email} = this.state.form.elements;

        const params = {
            account_code: this.props.account_code,
            firstname:firstname.value,
            lastname:lastname.value,
            phone:phone.value,
            email:email.value
        }

        axios.get('/generate-creation-token', {params: params})
            .then((response) => {
                if(response.data.succeeded){
                    navigator.clipboard.writeText(response.data.data.token_url);
                    this.setState({
                        loading: false,
                        generated_url: response.data.data.token_url
                    });
                    toast.success(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t("popup.generate_token.messages.success") }
                            </div>
                        </div>
                    );
                    this.props.onSuccess(this.props.account_code, response.data.data.token_url)
                }
                else{
                    let errorMessages = [];
                    {Object.keys(response.data.errors).forEach(function (key) {
                        errorMessages.push(response.data.errors[key][0]);

                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );

                    this.setState({
                        formIsValid: false,
                        loading: false
                    });
                }

            }, (error) => {
                toast.error(
                    <div>
                        <i className="fal fa-exclamation-circle"></i>&nbsp;{error.message}
                    </div>
                );

                this.setState({
                    formIsValid: false,
                    loading: false
                });
            });
    };

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {...this.state.form};

        updatedForm.elements[inputIdentifier].value = event.target.value;

        const validationResult = this.checkValidity(updatedForm.elements[inputIdentifier], updatedForm.elements[inputIdentifier].value, updatedForm.elements[inputIdentifier].validationRules);

        updatedForm.elements[inputIdentifier].valid = validationResult.valid;
        updatedForm.elements[inputIdentifier].touched = true;
        updatedForm.elements[inputIdentifier].errorMessage = validationResult.errorMessages.join(', ')

        this.setState({
            form: updatedForm,
        });
    }

    checkValidity = (formElement,value,rules) => {
        let isValid = true;
        let errors = [];

        if(rules.required){
            const ruleValid = value.trim() !== ''
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.required))
            isValid = ruleValid && isValid;
        }

        if(rules.minLength){
            const ruleValid = value.length >= rules.minLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.minLength))
            isValid = ruleValid && isValid;
        }

        if(rules.maxLength){
            const ruleValid = value.length >= rules.maxLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.maxLength))
            isValid = value.length <= rules.maxLength && isValid;
        }

        if(rules.match){
            const ruleValid = this.state.form.elements[rules.match].value === value
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.match))
            isValid = ruleValid && isValid;
        }

        if(rules.matchRegex){
            let ruleValid = value.match(rules.matchRegex) != null
            if (!ruleValid && rules.nullable && value == '')
                ruleValid = true

            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.matchRegex))
            isValid = ruleValid && isValid;
        }

        return {valid:isValid,errorMessages:errors};
    }

    render() {
        const {loading, formIsValid, generated_url } = this.state;
        const {elements} = this.state.form;

        const formElements = [];
        for(let key in elements){
            let configs = elements[key];

            formElements.push({
                id: key,
                configs: configs
            })
        }

        return (
            <div className="container container--larger linked-account-add-form">
                <div className="row flex flex--wrap">
                    <div className="col-sm-12">
                        <PageTitle title={this.props.t("popup.generate_token.title") + ' | ' + this.props.account_code}/>
                    </div>
                </div>

                {loading?
                    <Spinner />
                :
                    generated_url != '' ?
                        <div>
                            <div>{this.state.generated_url}&nbsp;<button onClick={this.copyClipboard} className={'btn btn-secondary btn-sm'}>
                                {this.props.t("popup.generate_token.copy_to_clipboard")}&nbsp;&nbsp;
                                <i className="fas fa-copy"></i>
                            </button>
                            </div>

                            <br />
                            <button onClick={this.props.closePopup} className={'btn btn-primary btn-sm'}>
                                {this.props.t("popup.generate_token.close")}&nbsp;&nbsp;<i
                                className="fas fa-angle-right"></i>
                            </button>
                        </div>
                        :
                        <div className="row">
                            <div className={'col-sm-12'}>
                                <p>{this.props.t("linkedaccounts.form.add.instructions")}</p>
                                <br />
                            </div>
                            {formElements.filter(item => item.configs.visible).map(element => (
                                <div key={element.id} className={element.configs.className}>
                                    {
                                        <Input key={element.id}
                                               label={element.configs.label}
                                               elementtype={element.configs.elementType}
                                               elementconfigs={element.configs.elementConfigs}
                                               value={element.configs.value}
                                               valid={element.configs.valid}
                                               shouldValidate={element.configs.validationRules}
                                               touched={element.configs.touched}
                                               changed={(event) => this.inputChangedHandler(event,element.id)}
                                               errorMessage={element.configs.errorMessage}/>
                                    }
                                </div>

                            ))}

                            <div className="col-sm-12 form__action">

                                <button onClick={this.props.closePopup} className={'btn btn-primary btn-sm'}>
                                    {this.props.t("popup.generate_token.form.cancel")}&nbsp;&nbsp;<i
                                    className="fas fa-angle-right"></i>
                                </button>
                                <button type="submit" className="btn btn--raised--red btn--raised"
                                        onClick={this.generateCreationToken}>
                                    {this.props.t("popup.generate_token.form.submit")}&nbsp;&nbsp;<i
                                    className="fas fa-angle-right"></i>
                                </button>
                            </div>
                        </div>
                }
            </div>
        )
    }
}

export default withTranslation()(NewAccountForm);
